<template>
    <CRow>
        <CCol col="12" lg="12">
            <CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade>
                {{ alertMessage }}
            </CAlert>

            <CCard>
                <CCardHeader>
                    <strong>{{ $lang.scholarship.crud.edit }}</strong>
                </CCardHeader>

                <CForm novalidate @submit.prevent="onSubmit" enctype='multipart/form-data'>
                    <CCardBody>
                        <CRow>
                            <CCol md="6">
                                <div class="form-group" :class="{ 'form-group--error': $v.scholarship.title.$error }">
                                    <label class="form__label">Title <required_span /></label>
                                    <input type="text" class="form-control" v-model="scholarship.title" />
                                    <small class="error" v-if="$v.scholarship.title.$error">{{
                                        $lang.scholarship.validation.required.title
                                    }}</small>
                                </div>
                            </CCol>
                            <CCol md="6">
                                <div class="form-group" :class="{ 'form-group--error': $v.scholarship.type.$error }">
                                    <label class="form__label">Type </label>
                                    <v-select :options="scholarshipTypeOption" v-model="scholarship.type" />
                                    <small class="error" v-if="$v.scholarship.type.$error">{{
                                        $lang.scholarship.validation.required.type }}</small>
                                </div>
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol md="12">
                                <div class="form-group">
                                    <label class="form__label">Tags</label>
                                    <v-select
                                        v-model="scholarship.tags"
                                        :options=scholarshipTagsOption
                                        multiple
                                        :taggable="true"
                                        :close-on-select="false"
                                        placeholder="Type and press Enter to add tags"
                                    />
                                    <!-- <input type="text" class="form-control" v-model="scholarship.tags" /> -->
                                </div>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="12">
                                <div class="form-group" :class="{ 'form-group--error': $v.scholarship.summary.$error }">
                                    <label class="form__label">Short Summary <required_span /></label>
                                    <textarea class="form-control" v-model="scholarship.summary" rows="3"></textarea>
                                    <small class="error" v-if="$v.scholarship.summary.$error">{{
                                        $lang.scholarship.validation.required.summary
                                    }}</small>
                                </div>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="12">
                                <div class="form-group">
                                    <label class="form__label">Benefits</label>
                                    <textarea class="form-control" v-model="scholarship.benefits" rows="3"></textarea>
                                </div>
                            </CCol>
                        </CRow>
                        <hr />
                        <h5>Application Process</h5>
                        <CRow class="margin-bottom-20">
                            <CCol md="6">
                                <div class="form-group" :class="{ 'form-group--error': $v.scholarship.application_mode.$error }">
                                    <label class="form__label">Application Mode</label>
                                    <v-select :options="applicationModeOption" v-model="scholarship.application_mode" @input="onApplicationModeChange"/>
                                    <small class="error" v-if="$v.scholarship.application_mode.$error">{{
                                        $lang.scholarship.validation.required.application_mode
                                    }}</small>
                                </div>
                            </CCol>
                            <CCol v-if="scholarship.application_mode_value == 1 || scholarship.application_mode_value == 3" md="6">
                                <div class="form-group">
                                    <label class="form__label">Application URL</label>
                                    <input type="url" class="form-control" v-model="scholarship.application_url" />
                                </div>
                            </CCol>
                            <CCol v-if="scholarship.application_mode_value == 2 || scholarship.application_mode_value == 3" md="6">
                                <label class="form__label">Application Locations</label>
                                <div v-for="(location, index) in scholarship.application_locations" :key="index" class="mb-2">
                                    <div class="d-flex align-items-center">
                                        <input type="text" class="form-control"
                                            v-model="scholarship.application_locations[index]" />
                                        <CButton v-if="scholarship.application_locations.length > 1"
                                            @click="removeLocation(index)" color="danger" size="sm" class="ml-2">
                                            Remove
                                        </CButton>
                                    </div>
                                </div>
                                <CButton @click="addLocation" color="primary" size="sm">Add Location</CButton>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="6">
                                <div class="form-group">
                                    <label class="form__label">Provider Type</label>
                                    <v-select :options="providerTypeOption" v-model="scholarship.provider_type" multiple />
                                </div>
                            </CCol>

                            <CCol md="6">
                                <div class="form-group">
                                    <label class="form__label">Required Documents</label>
                                    <v-select :options="requiredDocumentsOption" v-model="scholarship.required_document" multiple />
                                </div>
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol md="12">
                                <div class="form-group">
                                    <label class="form__label">How to Apply</label>
                                    <textarea class="form-control" v-model="scholarship.how_to_apply" rows="5"></textarea>
                                </div>
                            </CCol>
                        </CRow>
                        <hr />
                        <h5>Application Timeline</h5>
                        <CRow>
                            <CCol md="6">
                                <div class="form-group">
                                    <label class="form__label">Academic Year</label>
                                    <input type="text" class="form-control" v-model="scholarship.academic_year" />
                                </div>
                            </CCol>
                            <CCol md="6">
                                <div class="form-group">
                                    <label class="form__label">Result Date</label>
                                    <input type="date" class="form-control" v-model="scholarship.result_date" />
                                </div>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="6">
                                <div class="form-group"
                                    :class="{ 'form-group--error': $v.scholarship.startDate.$error }">
                                    <label class="form__label">Start Date <required_span /></label>
                                    <input type="date" class="form-control" v-model="scholarship.startDate" />
                                    <small class="error" v-if="$v.scholarship.startDate.$error">{{
                                        $lang.scholarship.validation.required.startDate
                                    }}</small>
                                </div>
                            </CCol>

                            <CCol md="6">
                                <div class="form-group"
                                    :class="{ 'form-group--error': $v.scholarship.endDate.$error }">
                                    <label class="form__label">End Date <required_span /></label>
                                    <input type="date" class="form-control" v-model="scholarship.endDate" />
                                    <small class="error" v-if="$v.scholarship.endDate.$error">{{
                                        $lang.scholarship.validation.required.endDate }}</small>
                                </div>
                            </CCol>
                        </CRow>
                        <hr />
                        <h5>Eligibility Criteria</h5>
                        <CRow>
                            <CCol md="4">
                                <div class="form-group">
                                    <label class="form__label">Programmes </label>
                                    <v-select :options="collegeProgrammesOption" v-model="scholarship.college_programme" @input="onCollegeProgrammesChange" />
                                </div>
                            </CCol>

                            <CCol md="4">
                                <div class="form-group">
                                    <label class="form__label">Stream </label>
                                    <v-select :options="collegeStreamOption" v-model="scholarship.college_stream"  @input="onCollegeStreamChange" />
                                </div>
                            </CCol>

                            <CCol md="4">
                                <div class="form-group">
                                    <label class="form__label">Disciplines </label>
                                    <v-select :options="collegeDisciplinesOption" v-model="scholarship.college_disciplines" multiple />
                                </div>
                            </CCol>
                        </CRow>
                        <CRow>
                             <CCol md="6">
                                <div class="form-group">
                                    <label class="form__label">Marks Type</label>
                                    <v-select :options="marksTypeOption" v-model="scholarship.marks_type" @input="onMarksTypeChange"/>
                                </div>
                            </CCol>
                            <CCol md="6" v-if="scholarship.marks_type.id == 1">
                                <div class="form-group">
                                    <label class="form__label">Min Percentage</label>
                                    <input type="number" class="form-control" v-model="scholarship.min_percentage" />
                                </div>
                            </CCol>

                            <CCol md="3" v-if="scholarship.marks_type.id == 2">
                                <div class="form-group">
                                    <label class="form__label">GPA Score</label>
                                    <input type="number" step="0.01" class="form-control" v-model="scholarship.gpa_score" />
                                </div>
                            </CCol>
                            <CCol md="3" v-if="scholarship.marks_type.id == 2">
                                <div class="form-group">
                                    <label class="form__label">GPA Scale (for out of)</label>
                                    <input type="number" step="0.01" class="form-control" v-model="scholarship.gpa_scale" />
                                </div>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="3">
                                <div class="form-group">
                                    <label class="form__label">Currency</label>
                                    <v-select :options="currencyOption" v-model="scholarship.country_id" />
                                </div>
                            </CCol>

                            <CCol md="3">
                                <div class="form-group">
                                    <label class="form__label">Family Income(Annual)</label>
                                    <input type="number" class="form-control" v-model="scholarship.family_income" />
                                </div>
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol md="4">
                                <div class="form-group">
                                    <label class="form__label">Minimum Age Limit</label>
                                    <input type="number" class="form-control" v-model="scholarship.min_age_limit" />
                                </div>
                            </CCol>
                            <CCol md="4">
                                 <div class="form-group">
                                    <label class="form__label">Maximum Age Limit</label>
                                    <input type="number" class="form-control" v-model="scholarship.max_age_limit" />
                                </div>
                            </CCol>

                            <CCol md="4">
                                <div class="form-group">
                                    <label class="form__label">Gender Specific</label>
                                    <v-select :options="genderOption" v-model="scholarship.gender_specific" />
                                </div>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="12">
                                <div class="form-group">
                                    <label class="form__label">Other Criteria</label>
                                    <textarea class="form-control" v-model="scholarship.other_criteria" rows="3"></textarea>
                                </div>
                            </CCol>
                        </CRow>
                        <hr />
                        <h5>Additional Information</h5>
                        <CRow>
                            <CCol md="12">
                                <table class="table table-bordered">
                                    <tr>
                                        <th>Sequence</th>
                                        <th>Country</th>
                                        <th>State</th>
                                        <th>Action</th>
                                    </tr>
                                    <tr v-for="(lists,index) in scholarship.countryMenuList">
                                        <td>
                                            {{ index + 1 }}
                                        </td>
                                        <td>
                                            <v-select :id="lists.id" v-model="lists.selected"
                                            @input="onCountryChange(index,lists.selected)"
                                            :options="countryOption"></v-select>
                                        </td>
                                        <td>
                                            <v-select :id="lists.id" v-model="lists.state" :options="lists.stateList"
                                            multiple></v-select>
                                        </td>
                                        <td>
                                            <button type="button" class="btn btn-success" @click="addMenu">
                                            <i class="fa fa-plus"></i>
                                            </button>&nbsp;
                                        </td>
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="6">
                                <div class="form-group">
                                    <label class="form__label">Language Requirement</label>
                                    <v-select :options="languageOption" v-model="scholarship.language" multiple />
                                </div>
                            </CCol>
                            <CCol md="6">
                                <div class="form-group">
                                    <label class="form__label">Attachments (PDF, DOC, DOCX, Image)</label>
                                    <input type="file" class="form-control" multiple @change="handleAttachments" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif" />
                                    <ul v-if="scholarship.attachments && scholarship.attachments.length > 0">
                                        <li v-for="(attachment, index) in scholarship.attachments" :key="index">
                                            {{ attachment.name }}
                                        </li>
                                    </ul>
                                    <div v-if="scholarship.existingMedia && scholarship.existingMedia.length > 0" class="mt-3">
                                        <label class="form__label d-block">Existing Media:</label>
                                        <div class="d-flex flex-wrap">
                                            <div v-for="(media, index) in scholarship.existingMedia" :key="index" class="media-container mr-4 mb-3">
                                                <a :href="media.url" target="_blank" class="media-preview" title="Click to view">
                                                    <div v-if="media.type == 1" class="h-100">
                                                        <img :src="media.url" alt="Attachment Image" />
                                                    </div>
                                                    <div v-else-if="media.type == 3 || (media.fileName && media.fileName.toLowerCase().endsWith('.pdf'))" class="pdf-placeholder text-center">
                                                        <i class="fas fa-file-pdf fa-3x text-danger"></i>
                                                        <p class="small text-truncate mt-1 mb-0 w-100 px-1">{{ media.fileName }}</p>
                                                    </div>
                                                    <div v-else class="pdf-placeholder text-center">
                                                        <i class="fas fa-file fa-3x text-secondary"></i>
                                                        <p class="small text-truncate mt-1 mb-0 w-100 px-1">{{ media.fileName }}</p>
                                                    </div>
                                                </a>
                                                <button type="button" class="delete-overlay-btn" @click.stop.prevent="removeExistingMedia(index)" title="Remove">
                                                    <i class="fa fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CCol>
                        </CRow>
                        <hr />
                        <h5>Organization Details</h5>
                        <div v-for="(organization, index) in scholarship.organizations" :key="index">
                            <CRow class="mb-2">
                                <CCol md="6">
                                    <div class="form-group">
                                        <label class="form__label">Organization Name</label>
                                        <input type="text" class="form-control" v-model="scholarship.organizations[index].organization_name" />
                                    </div>
                                </CCol>
                                <CCol md="6">
                                    <div class="form-group">
                                        <label class="form__label">University / School Name</label>
                                        <input type="text" class="form-control" v-model="scholarship.organizations[index].university" />
                                    </div>
                                </CCol>
                            </CRow>
                            
                            <CRow>
                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">Contact Person Name</label>
                                        <input type="text" class="form-control" v-model="scholarship.organizations[index].contact_person_name" />
                                    </div>
                                </CCol>
                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">Designation</label>
                                        <input type="text" class="form-control" v-model="scholarship.organizations[index].designation" />
                                    </div>
                                </CCol>
                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">Email</label>
                                        <input type="email" class="form-control" v-model="scholarship.organizations[index].organization_email" />
                                    </div>
                                </CCol>
                            </CRow>

                            <CRow>
                                <CCol md="6">
                                    <div class="form-group">
                                        <label class="form__label">Phone Number</label>
                                        <div class="d-flex"> <div style="width: 30%; margin-right: 10px;"> <v-select :options="countryCodeOption" v-model="scholarship.organizations[index].country_code" />
                                            </div>
                                            <div style="width: 70%;"> <input type="tel" class="form-control" v-model="scholarship.organizations[index].organization_phone" />
                                            </div>
                                        </div>
                                    </div>
                                </CCol>
                                <CCol md="6">
                                    <div class="form-group">
                                        <label class="form__label">Alternate Phone Number</label>
                                        <div class="d-flex"> <div style="width: 30%; margin-right: 10px;"> <v-select :options="altCountryCodeOption" v-model="scholarship.organizations[index].alt_country_code" />
                                            </div>
                                            <div style="width: 70%;"> <input type="tel" class="form-control" v-model="scholarship.organizations[index].organization_alt_phone" />
                                            </div>
                                        </div>
                                    </div>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol md="6">
                                    <div class="form-group">
                                        <label class="form__label">Location</label>
                                        <input type="text" class="form-control" v-model="scholarship.organizations[index].location" />
                                    </div>
                                </CCol>

                                <CCol md="6">
                                    <div class="form-group">
                                        <label class="form__label">Website</label>
                                        <input type="url" class="form-control" v-model="scholarship.organizations[index].website" />
                                    </div>
                                </CCol>
                            </CRow>
                        </div>
                    </CCardBody>

                    <CCardFooter>
                        <CButton type="submit" size="sm" color="primary" :disabled="submitted">
                            <CIcon name="cil-check-circle" /> {{ $lang.buttons.general.crud.submit }}
                        </CButton>
                        <CButton class="ml-2" color="danger" size="sm" @click="cancel">
                            <CIcon name="cil-ban" /> {{ $lang.buttons.general.crud.cancel }}
                        </CButton>
                    </CCardFooter>

                </CForm>
            </CCard>
        </CCol>

    </CRow>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import { Mixin } from "/src/mixins/index.js";
import store from "/src/store/store.js";
import { scholarship } from "/src/store/url.js";
import { CCol, CSelect, CButton, CRow, CCard, CCardHeader, CForm, CCardBody, CCardFooter, CAlert, CIcon } from "@coreui/vue";


export default {
    name: "Create",
    components: { required_span, CCol, CSelect, CButton, CRow, CCard, CCardHeader, CForm, CCardBody, CCardFooter, CAlert, CIcon },
    mixins: [Mixin],

    data() {
        return {
            self: this,
            messageColor: "success",
            alertMessage: "",
            showAlert: false,
            dismissCountDown: 0,
            module: scholarship,
            submitted: false,
            scholarshipId: null, // To store the ID of the scholarship being edited
            applicationModeOption: [
                { id: 1, label: "Online" },
                { id: 2, label: "Offline" },
                { id: 3, label: "Both" },
            ],
            marksTypeOption: [
                { id: 1, label: "Percentage" },
                { id: 2, label: "GPA" }
            ],
            providerTypeOption: [
                { id: 1, label: "Government" },
                { id: 2, label: "Semi-Government" },
                { id: 3, label: "Private" },
            ],
            genderOption: [
                { id: 1, label: "All" },
                { id: 2, label: "Male" },
                { id: 3, label: "Female" }
            ],
            languageOption: [],
            requiredDocumentsOption: [],
            scholarshipTypeOption:[],
            scholarshipTagsOption: [],
            collegeProgrammesOption: [],
            collegeStreamOption: [],
            collegeDisciplinesOption: [],
            countryCodeOption: [],
            altCountryCodeOption: [],
            currencyOption: [],
            countryOption: [],
            stateOption: [],
            scholarship: {
                id: "",
                title: "",
                summary: "",
                academic_year: "",
                application_mode: "",
                application_mode_value: "",
                provider_type: "",
                type: null,
                college_programme: "",
                college_stream: "",
                college_disciplines: [],
                application_url: "",
                how_to_apply: "",
                language: "",
                startDate: "",
                endDate: "",
                result_date: "",
                country: "",
                state: "",
                benefits: "",
                attachments: [],
                existingMedia: [],
                removeAttachmentsId: null,
                required_document: [],
                tags: "",
                min_percentage: null,
                gpa_score: null,
                gpa_scale: null,
                marks_type: {},
                family_income: null,
                country_id: null,
                min_age_limit: null,
                max_age_limit: null,
                gender_specific: {},
                other_criteria: "",
                organizations: [{  organization_name: '', university: '', contact_person_name: '', designation: '', organization_email: '', country_code:'', organization_phone: '', alt_country_code:'',organization_alt_phone: '', location: '', website: '' }],
                countryMenuList: [{
                    id: '0',
                    selected: '',
                    state: [],
                    stateList: []
                }],
                application_locations: [], // new
            },
            menuCounter: 0,
        }
    },

    validations: {
        scholarship: {
            title: { required },
            type: { required },
            summary: { required },
            startDate: { required },
            endDate: { required },
            application_mode: { required }
        },
    },
    async mounted() {
        let self = this;
        store.commit('showLoader', false);
        self.dismissCountDown = 0;
        localStorage.setItem("showAlert", "");

        // Get scholarship ID from route params
        self.scholarshipId = self.$route.params.id;

        axios.post(self.module.api.document).then((response) => {
            self.requiredDocumentsOption = response.data.data.map(requiredDocumentsData => ({
                id: requiredDocumentsData.id,
                label: requiredDocumentsData.title,
            }));
        }).catch((error) => {
            console.error("Failed to fetch requiredDocumentsData", error);
            this.scholarshipTagsOption = [];
        });

        axios.post(self.module.api.language).then((response) => {
            self.languageOption = response.data.data.map(languageData => ({
                id: languageData.id,
                label: languageData.title,
            }));
        }).catch((error) => {
            console.error("Failed to fetch language", error);
            this.scholarshipTagsOption = [];
        });


        axios.post(self.module.api.collegeProgrammes).then((response) => {
            self.collegeProgrammesOption = response.data.data;
        }).catch((error) => {
            console.error("Failed to fetch collegeProgrammes list", error);
            this.collegeProgrammesOption = [];
        });

        axios.post(self.module.api.type).then((response) => {
            self.scholarshipTypeOption = response.data.data;
        }).catch((error) => {
            console.error("Failed to fetch scholarshipType list", error);
            this.scholarshipTypeOption = [];
        });

        axios.get(self.module.api.currency).then((response) => {
            self.currencyOption = response.data.data.map(currencyData => ({
                id: currencyData.id,
                label: `${currencyData.currencySymbol} (${currencyData.name})`,
            }));
            self.countryOption = response.data.data.map(currencyData => ({
                id: currencyData.id,
                label: currencyData.name,
            }));
            self.countryCodeOption = response.data.data.map(currencyData => {
                const dialCode = String(currencyData.dialCode); // Ensure it's a string
                const formattedDialCode = dialCode.startsWith('+') ? dialCode : '+' + dialCode;
                return {
                    id: currencyData.id,
                    label: formattedDialCode,
                };
            });

            self.altCountryCodeOption = response.data.data.map(currencyData => {
                const dialCode = String(currencyData.dialCode); // Ensure it's a string
                const formattedDialCode = dialCode.startsWith('+') ? dialCode : '+' + dialCode;
                return {
                    id: currencyData.id,
                    label: formattedDialCode,
                };
            });
        }).catch((error) => {
            console.error("Failed to fetch currency and country list", error);
            this.currencyOption = [];
            this.countryOption = [];
            this.countryCodeOption = [];
            this.altCountryCodeOption = [];
        });

        axios.post(self.module.api.tags,{'entity' : "Scholarship"}).then((response) => {
            self.scholarshipTagsOption = response.data.data.map(tagsData => ({
                id: tagsData.id,
                label: tagsData.title,
            }));
        }).catch((error) => {
            console.error("Failed to fetch currency and country list", error);
            this.scholarshipTagsOption = [];
        });

        // Fetch scholarship data if ID exists (for editing)
        if (self.scholarshipId) {
            await self.fetchScholarshipData(self.scholarshipId);
        }
    },
    methods: {
        async fetchScholarshipData(id) {
            store.commit('showLoader', true);
            try {
                let self = this;
                const payload = { "id": id }; // Use the 'id' parameter passed to the function
                const response = await axios.post(self.module.api.view, payload);
                const data = response.data.data;

                self.scholarship.id = data.id || null;
                self.scholarship.title = data.title || null;
                self.scholarship.type = {
                    "id": data.scholarshipType.id,
                    "label": data.scholarshipType.title
                }; 
                self.scholarship.gender_specific = {
                    "id": data.gender.id,
                    "label": data.gender.title
                };
                  
                self.scholarship.country_id = {
                    "id": data.currency.id,
                    "label": `${data.currency.currencySymbol} (${data.currency.name} (${data.currency.isoCode}))`,
                };  
                self.scholarship.provider_type = data.providerType
                ? data.providerType.map(tag => ({
                    id: tag.id,
                    label: tag.title
                    }))
                : [];
                self.scholarship.required_document = data.requiredDocuments
                ? data.requiredDocuments.map(requiredDocument => ({
                    id: requiredDocument.id,
                    label: requiredDocument.title
                    }))
                : [];
                
                self.scholarship.college_programme = {
                    "id": data.programme.id,
                    "label": data.programme.title
                }; 
                if (self.scholarship.college_programme) {
                    await self.onCollegeProgrammesChange({
                        value:self.scholarship.college_programme
                    }); // Fetch stream options

                    self.scholarship.college_stream = {
                        "id": data.stream.id,
                        "label": data.stream.title
                    };
                    if(data.stream){
                         await self.onCollegeStreamChange({
                            value:data.stream.id
                        }); // Fetch stream options
                        self.scholarship.college_disciplines = data.discipline
                        ? data.discipline.map(tag => ({
                            id: tag.id,
                            label: tag.title
                            }))
                        : [];
                    }
                }
                self.scholarship.summary = data.summary || null; 
                self.scholarship.academic_year = data.academicYear || null; 
                self.scholarship.application_url = data.applicationUrl || null; 
                self.scholarship.how_to_apply = data.howToApply || null; 
                self.scholarship.min_age_limit = data.minAge || null; 
                self.scholarship.max_age_limit = data.maxAge || null;
                self.scholarship.startDate = data.applicationStartDate || '';
                self.scholarship.endDate = data.applicationEndDate || '';
                self.scholarship.result_date = data.resultDate || '';
                self.scholarship.benefits = data.benefits || '';

                self.scholarship.organizations[0].organization_name = data.organizationName || '';
                self.scholarship.organizations[0].university = data.instituteName || '';
                self.scholarship.organizations[0].contact_person_name = data.contactPersonName || '';
                self.scholarship.organizations[0].designation = data.contactPersonTitle || '';
                self.scholarship.organizations[0].organization_email = data.email || '';

                let foundCountryOption = self.countryCodeOption.find(option => option.label === data.countryCodeAlternate);

                self.scholarship.organizations[0].country_code = {
                    id: foundCountryOption ? foundCountryOption.id : '', // Use the found id, or an empty string if not found
                    label: data.countryCode || '', // Keep the label as data.countryCodeAlternate as per your original intent
                };
               
                self.scholarship.organizations[0].organization_phone = data.mobileNumber || '';
                let foundAltCountryOption = self.altCountryCodeOption.find(option => option.label === data.countryCodeAlternate);

                self.scholarship.organizations[0].alt_country_code = {
                    id: foundAltCountryOption ? foundAltCountryOption.id : '', // Use the found id, or an empty string if not found
                    label: data.countryCodeAlternate || '', // Keep the label as data.countryCodeAlternate as per your original intent
                };

                self.scholarship.organizations[0].organization_alt_phone = data.alternateMobileNumber || '';
                self.scholarship.organizations[0].location = data.location || '';
                self.scholarship.organizations[0].website = data.website || '';
                // self.scholarship.organizations = [{
                //     organization_name: data.organizationName || '',
                //     university: data.instituteName || '',
                //     contact_person_name: data.contactPersonName || '',
                //     designation: data.contactPersonTitle || '',
                //     organization_email: data.email || '',
                //     country_code: data.countryCode || '',
                //     organization_phone: data.mobileNumber || '',
                //     alt_country_code:data.countryCodeAlternate || '',
                //     organization_alt_phone: data.alternateMobileNumber || '',
                //     location: data.location || '',
                //     website: data.website || ''
                // }];
                self.scholarship.tags = data.tags
                ? data.tags.map(tag => ({
                    id: tag.id,
                    label: tag.title
                    }))
                : [];
                self.scholarship.language = data.languages
                ? data.languages.map(language => ({
                    id: language.id,
                    label: language.title
                    }))
                : [];
                self.scholarship.min_percentage = data.percentage;
                self.scholarship.gpa_score = data.gpa;
                self.scholarship.gpa_scale = data.gpaScale;
                self.scholarship.marks_type = self.marksTypeOption.find(option => option.id == data.marksType) || {};
                self.scholarship.family_income = data.income;
                self.scholarship.other_criteria = data.otherRequirements;
                
                self.scholarship.application_mode = {
                    "id": data.applicationMode.id,
                    "label": data.applicationMode.title
                };
                if(data.applicationMode.id){
                    this.scholarship.application_mode_value = data.applicationMode.id;
                }
                self.scholarship.application_locations = data.scholarshipLocation.arrayData || [];
                
                if (data.countryData && data.countryData.length > 0) {
                    self.scholarship.countryMenuList = data.countryData.map((country, index) => {
                        const item = {
                            id: index.toString(),
                            selected: { id: country.id, label: country.name },
                            state: (country.states && country.states[0] && country.states[0].id !== null)
                                ? country.states.map(s => ({ id: s.id, label: s.name }))
                                : [],
                            stateList: []
                        };
                        
                        // Fetch the full state list for this country to populate the dropdown
                        axios.post(self.module.api.states, { countryId: country.id }).then(response => {
                            if (response.data && response.data.data) {
                                item.stateList = response.data.data.map(s => ({ id: s.id, label: s.name }));
                            }
                        });

                        return item;
                    });
                } else {
                    self.scholarship.countryMenuList = [{
                        id: '0',
                        selected: '',
                        state: [],
                        stateList: []
                    }];
                }
                
                self.scholarship.existingMedia = data.media ? data.media.map(m => ({
                    id: m.id, // Assuming it has an id
                    fileName: m.fileName,
                    url: m.url,
                    type: m.type
                })) : [];

                store.commit('showLoader', false);
            } catch (error) {
                console.error("Failed to fetch scholarship data:", error);
                this.alertMessage = "Failed to load scholarship data.";
                this.messageColor = "danger";
                this.dismissCountDown = 10;
                store.commit('showLoader', false);
                this.$router.push({ path: "/scholarship" }); // Redirect on error
            }
        },
        cancel() {
            this.$router.push({ path: "/scholarship" });
        },
        onCollegeProgrammesChange(collegeProgrammes) {
            console.log("collegeProgrammes:",collegeProgrammes);
            let self = this;
            const collegeProgrammeId = collegeProgrammes.value;
            if (collegeProgrammeId) {
                axios.post(self.module.api.collegeStream, { programmeId: collegeProgrammeId }).then(response => {
                    self.collegeStreamOption = response.data.data.map(collegeStreamData => ({
                        id: collegeStreamData.id,
                        label: collegeStreamData.title,
                    }));
                });
            } else {
                self.collegeStreamOption = [];
            }
        },
        onCollegeStreamChange(collegeStream) {
            console.log("collegeStream:",collegeStream);
            let self = this;
            const collegeStreamId = collegeStream.value;
            console.log(collegeStreamId);
            if (collegeStreamId) {
                axios.post(self.module.api.collegeDiscipline, { streamId: collegeStreamId }).then(response => {
                    self.collegeDisciplinesOption = response.data.data.map(collegeDisciplinesData => ({
                        id: collegeDisciplinesData.id,
                        label: collegeDisciplinesData.title,
                    }));
                });
            } else {
                self.collegeDisciplinesOption = [];
            }
        },
        onCountryChange(index, val) {

            // console.log();
            let self = this;
            var postData = {
                'countryId' : val.value
            };
            axios.post(self.module.api.states, postData).then((response) => {
                self.scholarship.countryMenuList[index].state = [];
                self.scholarship.countryMenuList[index].stateList = [];
                response.data.data.map(function (value, key) {
                    //console.log({value: value.id, label: value.name});
                    self.scholarship.countryMenuList[index].stateList.push({id: value.id, label: value.name});
                });
            });
        },
        addMenu() {
            this.scholarship.countryMenuList.push({
                id: `${++this.menuCounter}`,
                selected: '',
                state: [],
                stateList: [],
            });
        },
        onCountryChangeOld(country) {
            let self = this;
            const countryId = country.value;
            if (countryId) {
                axios.post(self.module.api.states, { countryId: countryId }).then(response => {
                    self.stateOption = response.data.data.map(stateData => ({
                        id: stateData.id,
                        label: stateData.name,
                    }));
                });
            } else {
                self.stateOption = [];
            }
        },
        onApplicationModeChange(mode) {
            // console.log("mode",mode);
            if (mode.value === 2 || mode.value === 3) { // Offline
                if (!this.scholarship.application_locations || this.scholarship.application_locations.length === 0) {
                    this.scholarship.application_locations = [""]; // Initialize with one empty location
                }
            } else {
                this.scholarship.application_locations = []; // Clear locations
            }
            this.scholarship.application_mode_value = mode.value;
            // console.log("call",mode);
        },
        addLocation() {
            this.scholarship.application_locations.push("");
        },
        removeLocation(index) {
            this.scholarship.application_locations.splice(index, 1);
        },
        onMarksTypeChange(type) {
            // Save selected marks_type ID

            // Clear values when switching
            if (type.id === 1) {
                this.scholarship.gpa_score = null;
            } else if (type.id === 2) {
                this.scholarship.min_percentage = null;
            }
        },
        onSubmit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                
                const formData = new FormData();
                for (let key in this.scholarship) {
                    if (key === 'existingMedia') {
                        continue; // Skip existingMedia as it's only for UI display
                    }

                    if (key === 'attachments') {
                        this.scholarship.attachments.forEach((file, index) => {
                            formData.append(`attachments[${index}]`, file);
                        });
                    } else if (key === 'removeAttachmentsId') {
                        formData.append('removeAttachmentsId', this.scholarship.removeAttachmentsId || '');
                    } else if (key === 'organizations') {
                         this.scholarship.organizations.forEach((org, index) => {
                            for(let orgKey in org){
                                if (orgKey === 'country_code' || orgKey === 'alt_country_code') {
                                    // Ensure the value is an object before attempting to iterate
                                    if (typeof org[orgKey] === 'object' && org[orgKey] !== null) {
                                        // Append id and label of the country code object
                                        formData.append(`organizations[${index}][${orgKey}][id]`, org[orgKey].id || org[orgKey].value);
                                        formData.append(`organizations[${index}][${orgKey}][label]`, org[orgKey].label);
                                    }
                                } else {
                                    formData.append(`organizations[${index}][${orgKey}]`, org[orgKey]);
                                }
                            }
                         })
                    } else if (key === 'countryMenuList') { // Handle countryMenuList
                        this.scholarship.countryMenuList.forEach((countryMenu, countryIndex) => {
                            formData.append(`countryMenuList[${countryIndex}][id]`, countryMenu.id);
                            if(countryMenu.selected){
                                for (let selectedKey in countryMenu.selected) {
                                    formData.append(`countryMenuList[${countryIndex}][selected][${selectedKey}]`, countryMenu.selected[selectedKey]);
                                }
                            }


                            countryMenu.state.forEach((state, stateIndex) => {
                                 if(typeof state === 'object' && state !== null){
                                    for(let stateKey in state){
                                         formData.append(`countryMenuList[${countryIndex}][state][${stateIndex}][${stateKey}]`, state[stateKey]);
                                    }
                                 }
                                 else{
                                     formData.append(`countryMenuList[${countryIndex}][state][${stateIndex}]`, state);
                                 }
                            });
                           
                        });
                    }
                    else if (Array.isArray(this.scholarship[key])) {
                        this.scholarship[key].forEach((item, index) => {
                            if (typeof item === 'object' && item !== null) {
                                for (let itemKey in item) {
                                     formData.append(`${key}[${index}][${itemKey}]`, item[itemKey]);
                                }

                            }
                            else{
                                 formData.append(`${key}[${index}]`, item);
                            }
                        });
                    }
                     else if (typeof this.scholarship[key] === 'object' && this.scholarship[key] !== null) {
                        // Handle nested object,  append each property of the object
                        for (let propKey in this.scholarship[key]) {
                            formData.append(key + '[' + propKey + ']', this.scholarship[key][propKey]);
                        }
                    }
                    else {
                        formData.append(key, this.scholarship[key]);
                    }
                }
                this.submitted = true;
                setTimeout(() => {
                    axios.post(this.module.api.update, formData,{
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }).then((response) => {
                        this.submitted = false;
                        if (response.data.code == 200) {
                            this.alertMessage = response.data.message;
                            this.messageColor = "success";
                            this.showAlert = true;
                            this.dismissCountDown = 10;
                            this.$router.push({ path: "/scholarship" });
                        } else {
                            this.messageColor = "danger";
                            this.alertMessage = response.data.message || (response.data.error ? response.data.error[0] : "Something went wrong.");
                            this.showAlert = true;
                            this.dismissCountDown = 10;
                        }
                    })
                    .catch((error) => {
                        this.submitted = false;
                        this.messageColor = "danger";
                        if (error.response && error.response.data) {
                            this.alertMessage = error.response.data.message || (error.response.data.error ? error.response.data.error[0] : "Validation error.");
                        } else {
                            this.alertMessage = "Something went wrong.";
                        }
                        this.showAlert = true;
                        this.dismissCountDown = 10;
                    });
                }, 1000);
            } else {
                this.alertMessage = "Please fill in all required fields before submitting.";
                this.messageColor = "danger";
                this.showAlert = true;
                this.dismissCountDown = 5;
            }
        },
        handleAttachments(event) {
            this.scholarship.attachments = Array.from(event.target.files);
        },
        removeExistingMedia(index) {
            const media = this.scholarship.existingMedia[index];
            if (media.id) {
                if (this.scholarship.removeAttachmentsId) {
                    this.scholarship.removeAttachmentsId += ',' + media.id;
                } else {
                    this.scholarship.removeAttachmentsId = media.id.toString();
                }
            }
            this.scholarship.existingMedia.splice(index, 1);
        }
    }
};
</script>

<style scoped>
.error {
    color: red;
}
.margin-bottom-20 {
    margin-bottom: 20px;
}
.media-container {
    position: relative;
    width: 100px;
    height: 100px;
    border: 1px solid #ebedef;
    border-radius: 8px;
    background: #fff;
    transition: all 0.2s;
}
.media-container:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
.media-preview {
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-decoration: none;
    color: #4f5d73;
    border-radius: 8px;
}
.media-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.pdf-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.delete-overlay-btn {
    position: absolute;
    top: -12px;
    right: -12px;
    background: #ff0000;
    color: #fff;
    border: 2px solid #fff;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
    z-index: 5;
    padding: 0;
    font-size: 14px;
}
.delete-overlay-btn:hover {
    background: #d00000;
    transform: scale(1.1);
}
.delete-overlay-btn i {
    pointer-events: none;
}
</style>